import React from "react";
import { Container, Row, Col } from "shards-react";
import {firebases,files } from '../config';
import PageTitle from "../components/common/PageTitle";
import FormItem from "../components/common/FormItem";
import UserProfile from "../components/common/UserProfile";

const baseName = "SubCategory";
const firebaseDb = firebases.database().ref().child('subCategory');
const header = [{"field":"title","label":"Title","sort":"asc","type":"TEXT","editType":"textview"},{"field":"icon","label":"Icon","sort":"asc","type":"IMAGE","editType":"file"},{"field":"description","label":"Description","sort":"asc","type":"TEXT","editType":"textview"},{"field":"parentTitle","label":"Parent","sort":"asc","type":"TEXT","editType":"textview"},{"field":"","label":"","sort":"asc","type":"TEXT","editType":"textview"},{"label":"Actions","field":"actions","sort":"asc","width":110,"type":"ACTIONS"}];
let context = null;
class SubCategoryViewUpdate extends React.Component{

constructor(props){
super();
this.state = {item:{}};
context = this;
}

componentDidMount(){

this.fetchItemFromDb(this.props.match.params.id);
this.setState({id:this.props.match.params.id});
}


fetchItemFromDb = (id)=>{

  firebaseDb.child(id).on('value', snap => {
    
  
    let row = {};
    console.log(snap);
    snap.forEach(shot => {

      header.forEach(function(prop){


    
          row[shot.key] = shot.val();
        


      });

     
    });


    context.setState({item: row}); 
    


  });


}


render(){
  const {item,id} = this.state;
  return(
  <Container fluid className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title="SubCategory Profile" subtitle="Overview" md="12" className="ml-sm-auto mr-sm-auto" />
    </Row>
    <Row>
    {/*   <Col lg="4">
        <UserProfile item={item}/>
      </Col> */}
      <Col lg="10">
      <FormItem title="SubCategory Details" id={id} model={header} item={item} type="UPDATE" action="Update SubCategory" firebaseDb={firebaseDb} firebaseStorage={files} baseName={baseName}/>
      </Col>
    </Row>
  </Container>
);
}
}
export default SubCategoryViewUpdate;
